var map = {
	"./administracion/administracion.module": [
		"./src/app/crm/general/reporte/administracion/administracion.module.ts",
		"common",
		"administracion-administracion-module"
	],
	"./autorizar/autorizar.module": [
		"./src/app/crm/venta/nota-credito/autorizar/autorizar.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"common",
		"autorizar-autorizar-module"
	],
	"./b2b/b2b.module": [
		"./src/app/crm/general/b2b/b2b.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~etiqueta-etiqueta~e89247ea",
		"common",
		"b2b-b2b-module"
	],
	"./busqueda-producto/busqueda-producto.module": [
		"./src/app/crm/general/busqueda/busqueda-producto/busqueda-producto.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~etiqueta-etiqueta~e89247ea",
		"common",
		"busqueda-producto-busqueda-producto-module"
	],
	"./busqueda/busqueda.module": [
		"./src/app/crm/general/busqueda/busqueda.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~etiqueta-etiqueta~e89247ea",
		"common",
		"busqueda-busqueda-module"
	],
	"./compra-gasto/compra-gasto.module": [
		"./src/app/crm/contabilidad/compra-gasto/compra-gasto.module.ts",
		"compra-gasto-compra-gasto-module"
	],
	"./compra-grafica/compra-grafica.module": [
		"./src/app/crm/general/reporte/compra-grafica/compra-grafica.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"common",
		"compra-grafica-compra-grafica-module"
	],
	"./compra/compra.module": [
		"./src/app/crm/compra/compra/compra.module.ts",
		"common",
		"compra-compra-module"
	],
	"./contabilidad/contabilidad.module": [
		"./src/app/crm/general/reporte/contabilidad/contabilidad.module.ts",
		"common",
		"contabilidad-contabilidad-module"
	],
	"./control/control.module": [
		"./src/app/crm/logistica/control/control.module.ts",
		"control-control-module~crm-configuracion-configuracion-module~crm-soporte-soporte-module~etiqueta-et~26e50829",
		"common",
		"control-control-module"
	],
	"./crm/almacen/almacen.module": [
		"./src/app/crm/almacen/almacen.module.ts",
		"common",
		"crm-almacen-almacen-module"
	],
	"./crm/auth/auth.module": [
		"./src/app/crm/auth/auth.module.ts",
		"common",
		"crm-auth-auth-module"
	],
	"./crm/compra/compra.module": [
		"./src/app/crm/compra/compra.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"crm-compra-compra-module"
	],
	"./crm/configuracion/configuracion.module": [
		"./src/app/crm/configuracion/configuracion.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"control-control-module~crm-configuracion-configuracion-module~crm-soporte-soporte-module~etiqueta-et~26e50829",
		"common",
		"crm-configuracion-configuracion-module"
	],
	"./crm/contabilidad/contabilidad.module": [
		"./src/app/crm/contabilidad/contabilidad.module.ts",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"common",
		"crm-contabilidad-contabilidad-module"
	],
	"./crm/dashboard/dashboard.module": [
		"./src/app/crm/dashboard/dashboard.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"common",
		"crm-dashboard-dashboard-module"
	],
	"./crm/general/general.module": [
		"./src/app/crm/general/general.module.ts",
		"crm-general-general-module"
	],
	"./crm/inventario/inventario.module": [
		"./src/app/crm/inventario/inventario.module.ts",
		"crm-inventario-inventario-module"
	],
	"./crm/logistica/logistica.module": [
		"./src/app/crm/logistica/logistica.module.ts",
		"crm-logistica-logistica-module"
	],
	"./crm/pda/pda.module": [
		"./src/app/crm/pda/pda.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"common",
		"crm-pda-pda-module"
	],
	"./crm/soporte/soporte.module": [
		"./src/app/crm/soporte/soporte.module.ts",
		"control-control-module~crm-configuracion-configuracion-module~crm-soporte-soporte-module~etiqueta-et~26e50829",
		"common",
		"crm-soporte-soporte-module"
	],
	"./crm/usuario/usuario.module": [
		"./src/app/crm/usuario/usuario.module.ts",
		"common",
		"crm-usuario-usuario-module"
	],
	"./crm/venta/venta.module": [
		"./src/app/crm/venta/venta.module.ts",
		"crm-venta-venta-module"
	],
	"./devolucion/devolucion.module": [
		"./src/app/crm/soporte/garantia-devolucion/devolucion/devolucion.module.ts",
		"common",
		"devolucion-devolucion-module"
	],
	"./envio/envio.module": [
		"./src/app/crm/logistica/envio/envio.module.ts",
		"envio-envio-module"
	],
	"./estado/estado.module": [
		"./src/app/crm/contabilidad/estado/estado.module.ts",
		"estado-estado-module"
	],
	"./etiqueta/etiqueta.module": [
		"./src/app/crm/almacen/etiqueta/etiqueta.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~etiqueta-etiqueta~e89247ea",
		"control-control-module~crm-configuracion-configuracion-module~crm-soporte-soporte-module~etiqueta-et~26e50829",
		"common",
		"etiqueta-etiqueta-module"
	],
	"./factura/factura.module": [
		"./src/app/crm/contabilidad/factura/factura.module.ts",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"common",
		"factura-factura-module"
	],
	"./ftp/ftp.module": [
		"./src/app/crm/general/ftp/ftp.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~etiqueta-etiqueta~e89247ea",
		"common",
		"ftp-ftp-module"
	],
	"./garantia-devolucion/garantia-devolucion.module": [
		"./src/app/crm/soporte/garantia-devolucion/garantia-devolucion.module.ts",
		"garantia-devolucion-garantia-devolucion-module"
	],
	"./garantia/garantia.module": [
		"./src/app/crm/soporte/garantia-devolucion/garantia/garantia.module.ts",
		"common",
		"garantia-garantia-module"
	],
	"./guia/guia.module": [
		"./src/app/crm/logistica/guia/guia.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"guia-guia-module~pedido-pedido-module~venta-venta-module",
		"common",
		"guia-guia-module"
	],
	"./hp/hp.module": [
		"./src/app/crm/general/reporte/hp/hp.module.ts",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"common",
		"hp-hp-module"
	],
	"./importar-comercial/importarcomercial.module": [
		"./src/app/crm/contabilidad/importar-comercial/importarcomercial.module.ts",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"common",
		"importar-comercial-importarcomercial-module"
	],
	"./ingreso/ingreso.module": [
		"./src/app/crm/contabilidad/ingreso/ingreso.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"common",
		"ingreso-ingreso-module"
	],
	"./linio/venta-linio.module": [
		"./src/app/crm/venta/linio/venta-linio.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"common",
		"linio-venta-linio-module"
	],
	"./liverpool/venta-liverpool.module": [
		"./src/app/crm/venta/liverpool/venta-liverpool.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"liverpool-venta-liverpool-module"
	],
	"./logistica/logistica.module": [
		"./src/app/crm/general/reporte/logistica/logistica.module.ts",
		"logistica-logistica-module"
	],
	"./manifiesto/manifiesto.module": [
		"./src/app/crm/logistica/manifiesto/manifiesto.module.ts",
		"manifiesto-manifiesto-module"
	],
	"./mercadolibre/mercadolibre-venta.module": [
		"./src/app/crm/venta/venta/mercadolibre/mercadolibre-venta.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"mercadolibre-mercadolibre-venta-module"
	],
	"./mercadolibre/mercadolibre.module": [
		"./src/app/crm/general/reporte/venta/mercadolibre/mercadolibre.module.ts",
		"mercadolibre-mercadolibre-module"
	],
	"./mercadolibre/venta-mercadolibre.module": [
		"./src/app/crm/venta/mercadolibre/venta-mercadolibre.module.ts",
		"mercadolibre-venta-mercadolibre-module~publicacion-linio-publicacion-linio-module~publicacion-public~ae84e3e4",
		"common",
		"mercadolibre-venta-mercadolibre-module"
	],
	"./movimiento/movimiento.module": [
		"./src/app/crm/almacen/movimiento/movimiento.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"movimiento-movimiento-module"
	],
	"./nota-credito/nota-credito.module": [
		"./src/app/crm/venta/nota-credito/nota-credito.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-producto-module~compra-grafica-co~4b8caadc",
		"common",
		"nota-credito-nota-credito-module"
	],
	"./orden-compra/orden-compra.module": [
		"./src/app/crm/general/reporte/orden-compra/orden-compra.module.ts",
		"common",
		"orden-compra-orden-compra-module"
	],
	"./orden/orden.module": [
		"./src/app/crm/compra/orden/orden.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"orden-orden-module"
	],
	"./pedido/pedido.module": [
		"./src/app/crm/venta/venta/pedido/pedido.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"guia-guia-module~pedido-pedido-module~venta-venta-module",
		"common",
		"pedido-pedido-module"
	],
	"./pedimento/pedimento.module": [
		"./src/app/crm/compra/pedimento/pedimento.module.ts",
		"pedimento-pedimento-module"
	],
	"./pendientes/pendientes.module": [
		"./src/app/crm/general/reporte/pendientes/pendientes.module.ts",
		"pendientes-pendientes-module"
	],
	"./prestamo/prestamo.module": [
		"./src/app/crm/almacen/prestamo/prestamo.module.ts",
		"common",
		"prestamo-prestamo-module"
	],
	"./pretransferencia/pretransferencia.module": [
		"./src/app/crm/almacen/pretransferencia/pretransferencia.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"pretransferencia-pretransferencia-module"
	],
	"./producto/producto-reporte.module": [
		"./src/app/crm/general/reporte/producto/producto-reporte.module.ts",
		"common",
		"producto-producto-reporte-module"
	],
	"./producto/producto.module": [
		"./src/app/crm/compra/producto/producto.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"producto-producto-module"
	],
	"./productos/productos.module": [
		"./src/app/crm/general/reporte/venta/productos/productos.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"common",
		"productos-productos-module"
	],
	"./publicacion-linio/publicacion-linio.module": [
		"./src/app/crm/venta/linio/publicacion-linio/publicacion-linio.module.ts",
		"mercadolibre-venta-mercadolibre-module~publicacion-linio-publicacion-linio-module~publicacion-public~ae84e3e4",
		"publicacion-linio-publicacion-linio-module~publicacion-publicacion-module",
		"common",
		"publicacion-linio-publicacion-linio-module"
	],
	"./publicacion/publicacion.module": [
		"./src/app/crm/venta/mercadolibre/publicacion/publicacion.module.ts",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"mercadolibre-venta-mercadolibre-module~publicacion-linio-publicacion-linio-module~publicacion-public~ae84e3e4",
		"publicacion-linio-publicacion-linio-module~publicacion-publicacion-module",
		"common",
		"publicacion-publicacion-module"
	],
	"./publicaciones-marketplace/publicaciones-marketplace.module": [
		"./src/app/crm/venta/publicaciones-marketplace/publicaciones-marketplace.module.ts",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"common",
		"publicaciones-marketplace-publicaciones-marketplace-module"
	],
	"./reporte/reporte.module": [
		"./src/app/crm/general/reporte/reporte.module.ts",
		"reporte-reporte-module"
	],
	"./servicio/servicio.module": [
		"./src/app/crm/soporte/garantia-devolucion/servicio/servicio.module.ts",
		"servicio-servicio-module"
	],
	"./shopify/venta-shopify.module": [
		"./src/app/crm/venta/shopify/venta-shopify.module.ts",
		"common",
		"shopify-venta-shopify-module"
	],
	"./sistema/sistema.module": [
		"./src/app/crm/configuracion/sistema/sistema.module.ts",
		"common",
		"sistema-sistema-module"
	],
	"./usuario/usuario.module": [
		"./src/app/crm/configuracion/usuario/usuario.module.ts",
		"common",
		"usuario-usuario-module"
	],
	"./venta/reporte-venta.module": [
		"./src/app/crm/general/reporte/venta/reporte-venta.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"venta-reporte-venta-module"
	],
	"./venta/venta.module": [
		"./src/app/crm/venta/venta/venta.module.ts",
		"autorizar-autorizar-module~b2b-b2b-module~busqueda-busqueda-module~busqueda-producto-busqueda-produc~a28eec36",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"b2b-b2b-module~crm-configuracion-configuracion-module~crm-contabilidad-contabilidad-module~hp-hp-mod~d2bfb305",
		"crm-contabilidad-contabilidad-module~factura-factura-module~guia-guia-module~pedido-pedido-module~pu~6bf113a8",
		"guia-guia-module~pedido-pedido-module~venta-venta-module",
		"common",
		"venta-venta-module"
	],
	"./walmart/venta-walmart.module": [
		"./src/app/crm/venta/walmart/venta-walmart.module.ts",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~4f49c56f",
		"b2b-b2b-module~crm-compra-compra-module~crm-configuracion-configuracion-module~etiqueta-etiqueta-mod~1bb75d85",
		"common",
		"walmart-venta-walmart-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;